<template>
    <div class="el-main">
        <!-- <div class="card"
          v-show="currentCardId == 'occupation'">
          <div class="overflow-scroll-y">
            <div class="card-header">
              <h2>職種</h2>
              <p>後の入力項目で選択した職種に合わせた例文が使えます</p>
            </div>
            <div class="card-content">
              <div>
              <el-select v-model="formatData.occupation"
                placeholder="Select">
                <el-option v-for="item in occupationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
              </div>
            </div>
          </div>
        </div> -->

        <div class="card"
             v-show="currentCardId == 'company'">
            <div class="overflow-scroll-y">
                <div class="card-header">
                    <h2>받는분 이름(상호)</h2>
                    <p>송장에 기재할 회사명과 담당자 정보를 입력 해주세요.</p>
                </div>
                <div class="card-content">
                    <div class="edit-form">
                        <div class="edit-form-item">
                            <div class="item-name">받는 분 이름(상호)</div>
                            <div class="item-body">
                                <el-input placeholder="株式会社Yagish"
                                          class="input-md"
                                          title="応募する会社名"
                                          ref="letter-company"
                                          v-model="formatData.company_name"></el-input>
                            </div>
                        </div>
                        <div class="edit-form-item">
                            <div class="item-name">받는분 이름(호칭을 사용 하지 말아주세요.)</div>
                            <div class="item-body">
                                <el-input placeholder="담당자"
                                          class="input-md"
                                          title="수입회사당담자"
                                          ref="letter-staff"
                                          v-model="formatData.staff_name"></el-input>
                            </div>
                            <div class="attention-limit character"
                                 v-if="staff_name_Error">
                                <i class="el-icon-warning"></i> ~님 혹은 ~분을 발견 하였습니다. 호칭을 사용 하지 말아주세요.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card"
             v-show="currentCardId == 'intro'">

            <div class="overflow-scroll-y">
                <div class="card-header">
                    <h2>머릿말과 계절인사</h2>
                    <p>머릿말과 계절의 인사말을 입력 해주세요.</p>
                    <div class="add-item">
                        <el-button @click="$modal.show('intro-dialog')"
                                   style="background-color:#004D40;border-color:#004D40;"
                                   type="success">예문에서 추가</el-button>
                    </div>
                </div>
                <div class="card-content">
                    <modal name="intro-dialog"
                           :adaptive="true"
                           :scrollable="true"
                           height="auto">
                        <div class="v--modal-close-top">
                            <el-button @click="$modal.hide('intro-dialog');"
                                       icon="el-icon-close"
                                       type="text"></el-button>
                        </div>
                        <div class="title">예문선택</div>
                        <div class="description">
                            <p>선택한 예문이 추가되었습니다.</p>
                            <p class="attention">예문을 선택하면 현재 입력 중인 문장은 덮어쓰게 되므로 주의하시기 바랍니다.</p>
                        </div>
                        <ul class="example-sentence">
                            <li v-for="(item, index) in filtered(exampleSentences.intro)"
                                v-on:click="formatData.introSummary=item.sentences.replace(/<br>/ig, '\n');checklog();$modal.hide('intro-dialog')"
                                :key="index">
                                <div class="title">{{ item.name }}</div>
                                <div class="body"
                                     v-html="item.sentences"></div>
                            </li>
                        </ul>
                        <div class="text-right">
                            <el-button @click="$modal.hide('intro-dialog')">닫기</el-button>
                        </div>
                    </modal>
                    <el-input type="textarea"
                              v-model="formatData.introSummary"
                              :autosize="{minRows: 5, maxRows: 15}"></el-input>
                    <div class="attention-limit character"
                         v-if="previewErrors.introSummary">
                        <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.문장을 짧게 해주세요.
                    </div>
                </div>
            </div>
        </div>

        <div class="card"
             v-show="currentCardId == 'entry-detail'">
            <div class="overflow-scroll-y">
                <div class="card-header">
                    <h2>지원사유</h2>
                    <p>지원사유를 입력 해주세요.</p>
                    <div class="add-item">
                        <el-button @click="$modal.show('entry-dialog')"
                                   style="background-color:#004D40;border-color:#004D40;"
                                   type="success">예문에서추가</el-button>
                    </div>
                </div>
                <div class="card-content">
                    <modal name="entry-dialog"
                           :adaptive="true"
                           :scrollable="true"
                           height="auto">
                        <div class="v--modal-close-top">
                            <el-button @click="$modal.hide('entry-dialog');"
                                       icon="el-icon-close"
                                       type="text"></el-button>
                        </div>
                        <div class="title">예문선택</div>
                        <div class="description">
                            <p>선택한 예문이 추가되었습니다.</p>
                            <p class="attention">예문을 선택하면 현재 입력 중인 문장은 덮어쓰게 되므로 주의하시기 바랍니다.</p>
                        </div>
                        <ul class="example-sentence">
                            <li v-for="(item, index) in filtered(exampleSentences.entry)"
                                v-on:click="formatData.entrySummary=item.sentences.replace(/<br>/ig, '\n');checklog();$modal.hide('entry-dialog')"
                                :key="index">
                                <div class="title">{{ item.name }}</div>
                                <div class="body"
                                     v-html="item.sentences"></div>
                            </li>
                        </ul>
                        <div class="text-right">
                            <el-button @click="$modal.hide('entry-dialog')">닫기</el-button>
                        </div>
                    </modal>
                    <el-input type="textarea"
                              v-model="formatData.entrySummary"
                              :autosize="{minRows: 5, maxRows: 15}"></el-input>
                    <div class="attention-limit character"
                         v-if="previewErrors.entrySummary">
                        <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.문장을 짧게 해주세요.
                    </div>
                </div>
            </div>
        </div>

        <div class="card"
             v-show="currentCardId == 'resume-list'">
            <div class="overflow-scroll-y">
                <div class="card-header">
                    <h2>첨부서류</h2>
                    <p>첨부서류를 입력 해주세요.</p>
                </div>
                <div class="card-content">
                    <el-input type="textarea"
                              v-model="formatData.resumeSummary"
                              :autosize="{minRows: 5, maxRows: 15}"></el-input>
                    <div class="attention-limit character"
                         v-if="previewErrors.resumeSummary">
                        <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.문장을 짧게 해주세요.
                    </div>
                </div>
            </div>
        </div>

        <div class="card" v-show="currentCardId == 'create-date'">
            <div class="overflow-scroll-y">
                <div class="card-header">
                    <h2>송부 작성일 입력</h2>
                    <p>실제로 서류를 지참하는 날 또는 우편으로 보낼 날짜를 선택하세요 </p>
                </div>
                <div class="card-content">
                    <div class="edit-form-list">
                        <div class="create-date-action">
                            <div class="action-item">
                                <el-button class="button-block"
                                           :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getToday())"
                                           @click="formatData.createDate = $formLib.getToday()">오늘 날짜입력</el-button>
                            </div>
                            <div class="action-item">
                                <el-button class="button-block"
                                           :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getTommorow())"
                                           @click="formatData.createDate = $formLib.getTommorow()">내일 날짜입력</el-button>
                            </div>
                            <div class="action-item">
                                <el-date-picker v-model="formatData.createDate"
                                                type="date"
                                                :clearable="false"
                                                placeholder="선택 해주세요"
                                                :format="'yyyy년M월d일'"
                                                ref="create_date">
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div  v-if="$site.appFlag!='b' || true">
                        <el-collapse accordion v-model="activeName">
                            <el-collapse-item name="1">
                                <template slot="title" >
                                    <div class="yagitaku">
                                        <span class="yagitaku_recommend">추천</span>인쇄부터 우편까지 당신을 대신하여 !야기택배 서비스
                                    </div>
                                </template>
                                <div class="el-collapse-item__content">
                                    <p>취직 또는 이직을 희망하는 기업에게, 당신 대신 야기슈가 "이력서" ,"송부장","봉투"를 인쇄하여 발송해 드립니다.(경력기술서는 자유선택)<br></p>

                                    <div class="bnr_item create-date_bnr">
                                        <div class="bnr_txt create-date_txt">
                                            <el-button
                                                    style="width:100%;border:0px;padding:20px;background: #EFF8F8;color:#E3165C;font-size: 1.1rem;"
                                                    :disabled="!$deviceLib.isOnline ||!isSendYagiPostEnabled"
                                                    @click="$eventHub.$emit('send-special-post', formatId);">
                                                <h3>야기택배<span>이용하기</span></h3>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
            </div>
        </div>


        <div class="card" v-show="currentCardId == 'confirm'">
            <div class="overflow-scroll-y">
                <div class="card-header"  style="max-width: 40rem;margin: 2rem auto -3rem;">
                    <h2 >작성한송장확인</h2>
                </div>
            </div>
        </div>


        <div class="card" v-show="currentCardId == 'output'" v-if="getMode != 'production1'">

            <download-item :formatId="formatId"
                           :isSendYagiPostEnabled="isSendYagiPostEnabled"
                           :isSendYagiEmailEnabled="isSendYagiEmailEnabled"
                           :mailPdfEnabled="mailPdfEnabled"
                           :downloadPdfEnabled="downloadPdfEnabled"
                           :downloadActiveCollapses="downloadActiveCollapses"
            ></download-item>
        </div>


    </div>
</template>
<style lang="scss" scoped>
.yagitaku{
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}
.yagitaku_recommend{
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}
.yagitaku_link{
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}
.create-date_bnr{
  margin: 15px 0;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}






* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  vertical-align: bottom;
}
.next_bnr{
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}
.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}
.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}
.bnr_item {
  text-align: center;
}
.bnr_item img{
  border-radius: 10px 10px 0 0 ;
}
.bnr_txt{
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}
.txt{
  border-radius: 10px;
}
.bnr_txt p{
  font-size: 0.8rem;
  font-weight: bold;
  font-family: "M PLUS Rounded 1c";
}
.bnr_txt h3{
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}
.bnr_txt span{
  font-size: 0.8rem;
}
.create-date_txt {
  border-radius: 10px;
}
.bnr_note{
  font-size: 0.8rem;
}
.card-header h1{
  padding-bottom: 1.5rem;
}
.card-header h2{
  padding-bottom: 1.5rem;
}
/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}
/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}


</style>

<script>
// import HistoryItem from './RirekishoParts/HistoryItem'
import HistoryItemSkill from './ShokurekishoParts/HistoryItemSkill'
import HistoryItemJob from './ShokurekishoParts/HistoryItemJob'
// import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
// import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginSpecialForms'
import DownloadItem from './CommonParts/DownloadItem'

const uuidv4 = function () {
    const cryptoObj = window.crypto || window.msCrypto
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
}
const SkillHistoryData = function (columns) {
    this.skillname = columns.skillname || ''
    this.years = Number(columns.years) || ''
    this.description = columns.description || ''
    this.uuid = uuidv4()
}
// const SkillHistoryData2 = class sh {
//   constructor (columns) {
//     this.skillname = columns.skillname || ''
//     this.years = Number(columns.years) || ''
//     this.description = columns.description || ''
//     this.uuid = uuidv4()
//   }
//   run () {
//     return (this.uuid)
//   }
// }
const JobHistoryData = function (columns) {
    this.companyName = columns.companyName || ''
    this.startYear = Number(columns.startYear) || ''
    this.startMonth = Number(columns.startMonth) || ''
    this.endYear = Number(columns.endYear) || ''
    this.endMonth = Number(columns.endMonth) || ''
    this.isContinuing = columns.isContinuing || false
    this.capitalStock = columns.capitalStock || ''
    this.numberOfEmployees = columns.numberOfEmployees || ''
    this.businessArea = columns.businessArea || ''
    this.projects = columns.projects || []
    this.uuid = uuidv4()
}
const ProjectHistoryData = function (columns) {
    this.projectTitle = columns.projectTitle || ''
    this.startYear = Number(columns.startYear) || ''
    this.startMonth = Number(columns.startMonth) || ''
    this.endYear = Number(columns.endYear) || ''
    this.endMonth = Number(columns.endMonth) || ''
    this.contentsOfProject = columns.contentsOfProject || ''
    this.envAndScale = columns.envAndScale || ''
    this.position = columns.position || ''
    this.uuid = uuidv4()
}

export default {
    name: 'LetterEdit',
    props: {
        basicData: {
            type: Object,
            require: true
        },
        formatId: {
            type: String
        },
        previewFormat: {
            type: Object,
            require: true
        },
        currentCardId: {
            type: String
        },
        exampleSentences: {
            type: Object
        }
    },
    mixins: [LocalDataMixin],
    components: {
        'history-item': HistoryItemJob,
        'download-item': DownloadItem,
        'history-item-skill': HistoryItemSkill,
        // 'auto-job-histories': AutoJobHistories,
        'login-forms': LoginForms
    },
    data: function () {
        return {
            saveName: 'letter',
            saveOtherName: 'rirekisho',
            activeName: '1',
            formatData: {
                createDate: null,
                introSummary: '',
                entrySummary: '',
                resumeSummary: '',
                occupation: 'others',
                jobSummary: '',
                experienceAndKnowledge: '',
                skillsToUse: [],
                jobHistories: [],
                licenseHistories: [],
                prMessage: ''
            },
            isWeekEndFlag: true,
            staff_name_Error: false,
            activeHistoryItem: '',
            descriptionMaxLength: 80,
            mailPdfEnabled: true,
            downloadPdfEnabled: true,
            isSendYagiPostEnabled: true,
            isSendYagiEmailEnabled: true,
            eprintPdfEnabled: true,
            downloadActiveCollapses: ['postcard'],
            occupationOptions: [
                {
                    value: 'engineer',
                    label: '엔지니어'
                },
                {
                    value: 'sales',
                    label: '영업'
                },
                {
                    value: 'backoffice',
                    label: '사무'
                },
                {
                    value: 'others',
                    label: '기타'
                }
            ]
        }
    },
    computed: {
        previewErrors: function () {
            if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
            return this.previewFormat.errorMessages
        },
        optionItems: function () {
            if (!this.previewFormat || !this.previewFormat.optionItems) return {}
            return this.previewFormat.optionItems
        },
        isMynabi: function () {
            return (this.$yagi.isFromMynabi === 1)
        },
        getMode: function () {
            return process.env.VUE_APP_MODE
        }
    },
    watch: {
        formatData: function () {
            console.log(this.formatData.staff_name)
            if (this.formatData.jobHistories.length === 0) {
                // this.addJobHistory()
                // this.addProjectHistory(0)
                // this.createProjectHistoryItem()
                // console.log('asdf')
            }
        },
        'formatData.staff_name': function (newValue, oldValue) {
            console.log(newValue)
            if (newValue.indexOf('님') >= 0 || newValue.indexOf('분') >= 0) {
                this.staff_name_Error = true
            } else {
                this.staff_name_Error = false
            }
        }
    },
    methods: {
        filtered: function (obj) {
            var selectedOccupation = this.formatData.occupation
            return obj.filter(function (item) {
                return item.type === selectedOccupation
            })
        },
        setJobHistories: function (historyList) {
            // 先頭から追加
            for (let key in historyList) {
                let item = historyList[key]
                this.addJobHistory(null, {
                    year: item.year,
                    month: item.month,
                    description: item.desc
                })
            }
        },
        resetJobHistories: function () {
            this.formatData.jobHistories = []
        },
        createJobHistoryItem: function (columns) {
            if (!columns) columns = {}
            return new JobHistoryData(columns)
        },
        createProjectHistoryItem: function (columns) {
            if (!columns) columns = {}
            return new ProjectHistoryData(columns)
        },
        historySort: function (a, b) {
            let aYear = Number(a.year)
            let aMonth = Number(a.month)
            let bYear = Number(b.year)
            let bMonth = Number(b.month)
            if (aYear === bYear && aMonth === bMonth) {
                return 0
            }
            // 空欄は一番下に
            if (!aYear) aYear = 9999
            if (!aMonth) aMonth = 99
            if (!bYear) bYear = 9999
            if (!bMonth) bMonth = 99
            if (aYear > bYear) {
                return 1
            } else if (aYear < bYear) {
                return -1
            }
            if (aMonth > bMonth) {
                return 1
            } else if (aMonth < bMonth) {
                return -1
            }
            console.log('historySort failed')
            return 0
        },
        sortHistory: function (historyList) {
            // copy and sort
            return historyList.slice().sort(this.historySort)
        },
        checklog: function () {
            console.log(this.formatData)
        },
        addSkillHistory: function (index, columns) {
            const historyList = this.formatData.skillsToUse
            if (!columns) columns = {}
            const newHistoryItem = new SkillHistoryData(columns)
            if (typeof index === 'number') {
                historyList.splice(index, 0, newHistoryItem)
            } else {
                historyList.push(newHistoryItem)
            }
        },
        addJobHistory: function (index, columns) {
            const historyList = this.formatData.jobHistories
            if (!columns) columns = {}
            const newHistoryItem = new JobHistoryData(columns)
            if (typeof index === 'number') {
                historyList.splice(index, 0, newHistoryItem)
            } else {
                historyList.push(newHistoryItem)
            }
        },
        addProjectHistory: function (index, columns) {
            // const targetItem = this.formatData.jobHistories.find((item) => {
            //   return (item.uuid === this.activeHistoryItem)
            // })
            const targetItem = this.formatData.jobHistories[index]
            if (!columns) columns = {}
            const newHistoryItem = new ProjectHistoryData(columns)
            targetItem.projects.push(newHistoryItem)
        },
        moveSkillHistory: function (params) {
            this.moveHistory(this.formatData.skillsToUse, params)
        },
        moveJobHistory: function (params) {
            this.moveHistory(this.formatData.jobHistories, params)
        },
        moveJobHistoryDetail: function (params, parentIndex) {
            this.moveHistory(this.formatData.jobHistories[parentIndex].projects, params)
        },
        moveHistory: function (historyList, params) {
            const fromIndex = params.index
            const to = params.to
            if (fromIndex === 0 && to === 'up') {
                console.log('first item skip')
                return
            }
            if (fromIndex + 1 === historyList.length && to === 'down') {
                console.log('last item skip')
                return
            }
            if (to === 'up') {
                historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
            } else if (to === 'down') {
                historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
            } else {
                console.log('param "to" must be "up" or "down"')
            }
        },
        deleteSkillHistory: function (index) {
            this.formatData.skillsToUse.splice(index, 1)
        },
        deleteJobHistory: function (index) {
            this.formatData.jobHistories.splice(index, 1)
        },
        deleteHistoryDetail: function (index, index2) {
            console.log(index, index2)
            this.formatData.jobHistories[index].projects.splice(index2, 1)
        },
        activateHistoryItem: function (id) {
            this.activeHistoryItem = id
        },
        deactivateHistoryItem: function () {
            this.activeHistoryItem = ''
        },
        dataChanged: function () {
            console.error('dataChanged')
            this.mailPdfEnabled = true
            this.downloadPdfEnabled = true
        }
    },
    watch: {
        'formatData.createDate': function (newValue, oldValue) {
            this.formatData.writeDate = this.$formLib.dateFormat(newValue, 'yyyy년 m월 d일')
        }
    },
    created : function(){
        const nowdate = new Date()
        const date1 = new Date('2023/05/27 00:00:00')
        const date2 = new Date('2023/05/28 23:59:59')
        if (nowdate > date1 && nowdate < date2) {
            this.isWeekEndFlag = true
        } else {
            this.isWeekEndFlag = false
        }
        if (this.getMode != 'production') {
            this.isWeekEndFlag = true
        }
    },
    beforeMount: function () {
        if (this.formatData.createDate === null) {
            this.formatData.createDate = this.$formLib.getToday()
        }
        this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
        this.$eventHub.$on('basic-data-changed', this.dataChanged)
        this.$eventHub.$on('format-data-changed', this.dataChanged)
    },
    destroyed: function () {
        this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
        this.$eventHub.$off('basic-data-changed', this.dataChanged)
        this.$eventHub.$off('format-data-changed', this.dataChanged)
    }
}
</script>
<style scoped lang="scss">
</style>
